// extracted by mini-css-extract-plugin
module.exports = {"Container":"question_Container__1ebUw","form-control":"question_form-control__37ktY"};